import React, { useState } from 'react'
import Select from 'react-select';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CFormInput,
  CCol,
  CRow,
  CButton,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CFormLabel,
} from '@coreui/react'
import { DataGrid } from '@mui/x-data-grid'
import { Link, useLoaderData, useNavigate } from 'react-router-dom'
import AxiosInstance from 'src/components/Axios'
import { cilPen, cilPlus, cilTrash } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useEffect } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import AsyncSelect from 'react-select/async'
import imgQRCode from 'src/assets/images/doc_2024-10-10_10-27-10.png'


const page = 1
const urlApi_1 = '/account_jobs_lists'
const urlApi_2 = '/jobs'
const urlApi_3 = "/subpoenas"
const urlApi_4 = '/news'
const urlApi_5 = '/worker_proffesion_docs'
const urlRouter = '/accounts'
const urlApi_6 = 'worker_proffessions'



// хто увійшов
const role = localStorage.getItem('user_role')
// console.log(role)
// дані користувача
const userData = JSON.parse(localStorage.getItem('user_data'))

const tokenStr = localStorage.getItem('user')
const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }

// перше завантаження
export async function LoaderHome({ params }) {
  // const { page } = params;
  let query_1 = ''
  let query_2 = ''
  let query_3 = ''
  // let query_5 = 'status=send-to-verify'
  let queryDocs = 'status=send-to-verify'
  let query_5 = 'workerProffesionDocs.status=send-to-verify'

  // питання запиту
  if (role === 'ROLE_PARTNER') {
    // query_1 += `&user.id=${userData.id}`
    query_1 += `&account.user.id=${userData.id}`

    // query_2 += `&user.id=${userData.id}`
    query_2 += `&account.user.id=${userData.id}`
    // query_2 += `&user.id=${userData.id}`
    query_3 += `&account.user.id=${userData.id}`

    queryDocs += `&account.user.id=${userData.id}`

    query_5 += `&account.user.id=${userData.id}`
  }

  if (role === 'ROLE_ADMIN') {
    query_3 = `&subpoenaItems.synkStatus=send_to_verify` //запит до сервера
  }






  try {
    const response1 = await AxiosInstance.get(`${urlApi_1}?${query_1}`, header) //всі дозволи
    // console.log('response1', response1)

    const response2 = await AxiosInstance.get(`${urlApi_2}?${query_2}`, header) //всі роботи
    // console.log('response2', response2)

    const response3 = await AxiosInstance.get(`${urlApi_3}?${query_3}`, header) //всі приписи з send_to_verify
    // console.log('response2', response2)

    // тут запит за неперевіреними доками працівників
    // const response5 = await AxiosInstance.get(
    //   `${urlApi_5}?${query_5}`,
    //   header
    const responseDocs = await AxiosInstance.get(
      `${urlApi_5}?${queryDocs}&pagination=false`,
      header
    )
    // console.log('responseDocs', responseDocs)

    const response5 = await AxiosInstance.get(
      `${urlApi_6}?${query_5}&pagination=false`,
      header
    )
    // console.log('response5', response5)

    const response4 = await AxiosInstance.get(`${urlApi_4}?name=banner`, header) //запит за новиною

    return { data_1: response1.data, data_2: response2.data, data_3: response3.data, data_4: response4.data, data_5: response5.data, data_docs: responseDocs.data }
  } catch (error) {
    console.error('Помилка під час виконання запиту', error)
    return null
  }
}

// головний контент
const Workers = () => {
  // масиви даних
  const { data_1, data_2, data_3, data_4, data_5, data_docs } = useLoaderData() || {}
  // console.log('data_1', data_1)
  // console.log('data_2', data_2)
  // console.log('data_4', data_4)
  const navigate = useNavigate()
  const [dataState_1, setDataState_1] = useState(data_1)
  const [filterPermissionNotChecked, setFilterPermissionNotChecked] = useState(data_1)

  const [dataState_2, setDataState_2] = useState(data_2)
  const [filterJobNotChecked, setFilterJobNotChecked] = useState(data_2)

  const [dataState_3, setDataState_3] = useState(data_3)
  const [filterDirectivesNotChecked, setFilterDirectivesNotChecked] = useState(data_3)

  const [dataState_5, setDataState_5] = useState(data_5 || [])

  const [dataState_docs, setDataState_docs] = useState(data_docs || [])

  const [banner, setBanner] = useState(data_4[0] || {})

  const [openDocsDrawer, setOpenDocsDrawer] = useState(false)
  const [selectedWorker, setSelectedWorker] = useState(null);

  useEffect(() => {
    setDataState_1(data_1 || [])
    setDataState_2(data_2 || [])
    setDataState_3(data_3 || [])
    setDataState_5(data_5 || [])

    setBanner(data_4[0] || {})
    // console.log('dataState_1', dataState_1);
    // console.log('dataState_2', dataState_2);
  }, [data_1, data_2, data_3, data_4, data_5, data_docs])

  useEffect(() => {
    filterDateState_1()
    filterDateState_2()
    filterDateState_3()
  }, [dataState_1, dataState_2, dataState_3])

  const filterDateState_1 = () => {
    const newArr = dataState_1.filter((el) => el.status === 'not_checked')
    // console.log(newArr);
    setFilterPermissionNotChecked(newArr)
  }

  const filterDateState_2 = () => {
    const newArr = dataState_2.filter((el) => el.status === 'not_checked')
    setFilterJobNotChecked(newArr)
  }

  const filterDateState_3 = () => {
    // console.log('dateState_3', dataState_3)
    const newArr = dataState_3
    // .filter((el) => el.synkStatus === 'send_to_verify')
    setFilterDirectivesNotChecked(newArr)
  }



  const selectDocsOptions = (data_5 = [], dataDocs = []) => {
    return data_5
      .map(item => {
        const docs = item.workerProffesionDocs || [];
        if (!docs.length) return null;

        // знаходимо останній документ по id
        const lastDoc = docs.reduce((max, doc) => doc.id > max.id ? doc : max, docs[0]);

        // лишаєм тілько якщо статус send-to-verify
        if (lastDoc.status !== 'send-to-verify') return null;

        // знаходим воркера в data_docs для отримання fullName и id
        const docFromDataDocs = dataDocs.find(d => d.workerProffesion.id === item.id && d.id === lastDoc.id);
        console.log('lastDoc', lastDoc)
        console.log(' docFromDataDocs', docFromDataDocs)
        if (!docFromDataDocs) return null;

        return {
          value: `${docFromDataDocs.workerProffesion.worker.id}`,

          label: `${docFromDataDocs.workerProffesion.worker.fullName} (id професіі-${(docFromDataDocs.workerProffesion.id)}) ${item.workerProffessionList.name}`
        };
      })
      .filter(Boolean);
  };

  // console.log('кількысть дозволів',filterPermissionNotChecked.length);

  // console.log('role', role)

  // console.log('dataState', dataState_3)
  // console.log('data_5', data_5)
  // console.log('data_docs', data_docs)
  // console.log('selectedOptions', selectDocsOptions)
  // console.log('selectDocsOptions(dataState_5, dataState_docs)', selectDocsOptions(dataState_5, dataState_docs))
  return (
    <div className="d-flex justify-content-around">
      <div>
        {/* {role === 'ROLE_ADMIN' ?  */}
        <div className="d-flex text-align-center mb-3" style={{ fontWeight: 'bold' }}>
          <p>У вас {filterPermissionNotChecked.length} не підтверджені дозволи.</p>
          <Link to="/accounts" className="ms-3" state={{ status: 'not_checked' }}>
            <CButton type="submit" color="secondary">
              Переглянути
            </CButton>
          </Link>
        </div>
        {/* : ''} */}

        {/* {role === 'ROLE_ADMIN' &&  */}
        <div className="d-flex text-align-center mb-3" style={{ fontWeight: 'bold' }}>
          <p>У вас {filterJobNotChecked.length} не підтверджені роботи.</p>
          <Link to="/jobs" className="ms-3" state={{ status: 'not_checked' }}>
            <CButton type="submit" color="secondary">
              Переглянути
            </CButton>
          </Link>
        </div>
        {/* } */}

        {/* {role === 'ROLE_ADMIN' &&  */}
        <div className="d-flex text-align-center" style={{ fontWeight: 'bold' }}>
          <p>У вас {filterDirectivesNotChecked.length} не перевірені приписи.</p>
          <Link to="/directives" className="ms-3" state={{ synkStatus: 'send_to_verify' }}>
            <CButton type="submit" color="secondary">
              Переглянути
            </CButton>
          </Link>
        </div>
        {/* } */}

        {role === 'ROLE_ADMIN' && <>
          <div className="d-flex text-align-center mb-3 mt-2" style={{ fontWeight: 'bold' }}>
            {/* <p>У вас {dataState_5.length} неперевірених документів працівників.</p>  */}
            <p>У вас {selectDocsOptions(dataState_5, dataState_docs).length} неперевірених документів працівників.</p>
            {/* <Link to="/workers" className="ms-3" state={{ status: 'send-to-verify' }}> */}
            <CButton
              // onClick={() => setOpenDocsDrawer(true)}
              onClick={() => setOpenDocsDrawer(prev => !prev)}
              type="submit" color="secondary" >
              {openDocsDrawer ? 'Закрити' : 'Переглянути'}
            </CButton>
            {/* </Link> */}
          </div>
          {openDocsDrawer && (
            <div
              style={{
                padding: 20,
                // maxHeight: '70vh',
                overflowY: 'auto',
                border: '1px solid #ddd',
                borderRadius: 8,
                marginTop: 10,

              }}
            >
              <h4>Документи на перевірку</h4>

              {/* {dataState_5?.length === 0 ? ( */}
              {selectDocsOptions(dataState_5, dataState_docs).length === 0 ? (
                <p>Нема документів</p>
              ) :
                //  (
                //   <Select
                //     options={dataState_5.map(item => ({
                //       value: item.workerProffesion.worker.id,
                //       label: item.workerProffesion.worker.fullName
                //     }))}
                //     value={selectedWorker}
                //     // onChange={setSelectedWorker}
                //     onChange={(selected) => {
                //       if (selected?.value) {
                //         setSelectedWorker(selected)
                //         // window.location.href = `/workers/update/${selected.value}`;
                //         navigate(`/workers/update/${selected.value}`);
                //       }
                //     }}
                //     placeholder="Виберіть працівника"

                //     menuPortalTarget={document.body}
                //     styles={{
                //       menuPortal: base => ({ ...base, zIndex: 9999 }),
                //       container: base => ({ ...base, marginBottom: 20 })
                //     }}
                //   />
                // )
                (
                  <Select
                    options={selectDocsOptions(dataState_5, dataState_docs)}
                    value={selectedWorker}
                    onChange={(selected) => {
                      if (selected?.value) {
                        setSelectedWorker(selected)
                        navigate(`/workers/update/${selected.value}`);
                      }
                    }}
                    placeholder="Виберіть працівника"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      container: base => ({ ...base, marginBottom: 20 })
                    }}
                  />
                )
              }
            </div>
          )}
        </>
        }


        {banner?.news_full ? <div className="d-flex text-align-center" style={{ marginTop: "50px", fontWeight: '500', fontSize: '20px', color: '#ff1d1d' }}>
          {banner?.news_full || 'банер не знайдено'}
        </div> : ''}

      </div>

      <div>
        <img src={imgQRCode} style={{ height: '550px' }} />
      </div>
    </div>
  )
}

export default Workers
